<template>
  <base-content-block class="area-chart"
                      title="Rank Zone Time Progression">
    <div id="area-chart" class="area-chart__wrapper">
<!--      <button @click.prevent="toogleAnnotation"-->
<!--              v-if="!isScreenshotTaking"-->
<!--              class="area-chart__annotation-button"-->
<!--              :style="{ right: $refs.datepicker && $refs.datepicker.isOpened ? '416px' : '350px' }"-->
<!--              :class="{ 'area-chart__annotation-button_enabled': isAnnotationEnabled }">-->
<!--        annotations-->
<!--      </button>-->
      <base-area-chart-date-picker class="area-chart__date-picker"
                                   v-if="!isScreenshotTaking"
                                   ref="datepicker"
                                   :restrictions="dateRange"
                                   :dates="dates"
                                   @apply="onDateRangeChanged"/>
      <template>
        <div v-if="notEnoughData" class="rank-zone__no-data">Not enough data for drawing a chart</div>
        <div class="area-chart__chart-wrapper" v-else>
          <div class="area-chart__chart-subtitle" v-if="screenshotTitle">Rank Zone Time Progression -
            <span class="area-chart__chart-subtitle_highlighted">{{screenshotTitle}}</span>
          </div>
          <base-area-chart ref="areaChart" :chart-data="chartData" class="area-chart__chart"/>
        </div>
      </template>
      <div v-if="isAnnotationMarkersShown"
           ref="annotations"
           class="area-chart__annotation-icons"
           :style="annotationWrapperStyles">
        <template v-for="(annotation, index) in annotations">
          <base-material-design-icon :key="annotation.id"
                                     :iconStyle="{ 'margin-left': '-7px' }"
                                     :style="annotationStyles[index]"
                                     :class="[
                                         'area-chart__annotation-icons_icon',
                                         `area-chart__annotation-icons_icon_${annotation.prevType}`
                                     ]"
                                     icon="comment"
                                     @click="selectAnnotationDate(annotation.date)" />
        </template>
      </div>
      <div class="area-chart__checkboxes">
        <template v-for="(item, index) in columns">
          <div style="display: inline-block;" :key="item">
            <base-check-box class="area-chart__checkbox"
                            :label="item"
                            v-model="filters.columns[item]">
              <span class="area-chart__color" :style="{'background': allColors[index]}"/>
            </base-check-box>
            <button style="margin-left: 5px;"
                    :style="{'background-color': index === editorIndex ? 'red' : 'rgb(133, 133, 133)'}"
                    @click.prevent="openEditor(index)">color</button>
          </div>
        </template>
        <base-select class="area-chart__web-property-select"
                     v-if="!isScreenshotTaking"
                     :options="webPropertyGroups"
                     v-model="webPropertyGroupId"
                     :showTopBorder="true"
                     placeholder="Web Property">
          <template #type="{option}">
            <span v-if="option.type === 'Clients'" class="area-chart__client"/>
            <span v-else-if="option.type === 'Siblings'" class="area-chart__sibling"/>
            <span v-else-if="option.type === 'Competitors'" class="area-chart__competitor"/>
          </template>
        </base-select>
      </div>
      <base-annotations-manager v-if="isAnnotationEnabled && !isScreenshotTaking"
                                disableURL
                                :minDate="minDate"
                                :annotations="managerAnnotations"
                                v-model="annotationType"
                                @sortAnnotations="sortAnnotations"
                                @updateData="$emit('updateData')"
                                @close="toogleAnnotation"/>
      <ColorPicker v-if="Number.isInteger(editorIndex)"
                   class="list__color-picker"
                   :color="allColors[editorIndex]"
                   @color-change="updateColor">
        <template #alpha-range-input-label>
        </template>
        <template #copy-button>
          <span class="sr-only">Copy color</span>

          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
          >
            <path
              d="M5 0v2H1v13h12v-3h-1v2H2V5h10v3h1V2H9V0zm1 1h2v2h3v1H3V3h3z"
              fill="currentColor"
            />

            <path
              d="M10 7v2h5v2h-5v2l-3-3zM3 6h5v1H3zm0 2h3v1H3zm0 2h3v1H3zm0 2h5v1H3z"
              fill="currentColor"
            />
          </svg>
        </template>

      </ColorPicker>
    </div>
  </base-content-block>

</template>

<script>
/* eslint-disable no-unused-vars */
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import { convertAdvancedOptionsToFilters } from '@/features/reports/common/advanced-options/config'
import { ColorPicker } from 'vue-accessible-color-picker'

const emptyFilters = {
  columns: {},
  startDate: null,
  endDate: null
}
const allColors = [
  '#ff862c', '#f2d23e', '#008041',
  '#2ec4b6', '#284aff', '#9013fe',
  '#ff4f4f', '#c61919'
]
const MILISEC_ONE_DAY = 86400000
/**
 * Component is adapter for BaseAreaChart. Used in {@link Progress} tab
 */
export default {
  name: 'ColorAreaChart',
  props: {
    cells: {
      type: Array,
      required: true
    },
    selectedType: {
      type: String,
      default: null
    }
  },
  components: { ColorPicker },
  mounted () {
    this.countPixelsPerDate()
    window.addEventListener('resize', this.countPixelsPerDate)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.countPixelsPerDate)
  },
  data () {
    return {
      filters: { ...emptyFilters },
      chartData: {},
      editorIndex: null,
      selectedAdvancedOptions: [],
      webPropertyGroupId: null,
      annotationType: null,
      annotationSelectedDate: '',
      pxPerDate: 0,
      annotationsWrapperWidth: 0,
      isAnnotationEnabled: false,
      annotationWrapperStyles: {},
      isScreenshotTaking: false,
      allColors: [...allColors],
      throttle: _.throttle(
        () => {
          if (this.$refs.areaChart && this.$refs.annotations) {
            const chartElement = this.$refs.areaChart.$el.querySelector('rect')
            if (!chartElement) {
              this.$nextTick(() => {
                this.throttle()
              })
              return
            }
            const blockWidth = +chartElement.getAttribute('width')
            this.annotationsWrapperWidth = blockWidth
            const left = chartElement.getAttribute('x')
            this.annotationWrapperStyles = {
              width: blockWidth + 'px',
              left: left + 'px'
            }
            this.pxPerDate = blockWidth / (Math.round(Math.abs((this.chartData.ticks[0].v - this.chartData.ticks[this.chartData.ticks.length - 1].v) / MILISEC_ONE_DAY)))
          }
        },
        100,
        { leading: true, trailing: true }
      )
    }
  },
  watch: {
    allColors: {
      handler () {
        this.prepareChartData()
      },
      deep: true
    },
    clientId: {
      handler (v) {
        (v && this.webPropertyGroupId) && this.loadPageData()
      },
      immediate: true
    },
    webPropertyGroupId: {
      handler (v) {
        (v && this.clientId) && this.loadPageData()
      },
      immediate: true
    },
    cells: {
      handler (value) {
        /* force Vue reactivity system work properly */
        value.forEach(item => this.$set(this.filters.columns, item.label, !item.disabledByDefault))
      },
      immediate: true
    },
    isAnnotationMarkersShown (v) {
      v && this.$nextTick(this.countPixelsPerDate)
    },
    selectedType: {
      handler () {
        this.prepareChartData()
      },
      immediate: true
    },
    webPropertyGroups: {
      handler (groups) {
        if (groups.length) {
          /* set default webPropertyGroup */
          this.webPropertyGroupId = groups[0].value
        }
        this.sendWebPropertyGroup()
      },
      immediate: true
    },
    snapshots: {
      handler (value) {
        this.prepareChartData()
      },
      immediate: true
    },
    filters: {
      handler (value) {
        this.prepareChartData()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('rankZoneCommon', {
      /* prepare webPropertyGroup for dropdown */
      webPropertyGroups (state) {
        return state.webPropertyGroups.map(item => {
          return { value: item._id, label: item.label, type: item.type }
        }) || []
      }
    }),
    ...mapState('rankZoneProgress', {
      annotations (state) {
        return state.annotations.filter(i => {
          const startDate = this.filters.startDate || moment(this.minDate).subtract(1, 'days')
          const endDate = this.filters.endDate || moment(this.chartData.ticks[this.chartData.ticks.length - 1].v).add(1, 'days')
          const dateFilter = (!startDate || !endDate) || moment(i.prevDate).isBetween(startDate, endDate)

          const typeFilter = !this.annotationType || this.annotationType === i.prevType

          return dateFilter && typeFilter
        })
      },
      snapshots (state) {
        return _.get(state, 'progress', [])
      },
      managerAnnotations (state) {
        return state.annotations.filter(i => {
          const startDate = this.filters.startDate
          const endDate = this.filters.endDate
          const dateFilter = !this.annotationSelectedDate
            ? (!startDate || !endDate) || moment(i.prevDate).isBetween(startDate, endDate)
            : this.annotationSelectedDate === i.prevDate

          const typeFilter = !this.annotationType || this.annotationType === i.prevType

          return dateFilter && typeFilter
        })
      }
    }),
    minDate () {
      return this.chartData.ticks[0].v
    },
    columns () {
      return this.cells.map(item => item.label)
    },
    notEnoughData () {
      const isSomeColumnChecked = Object.values(this.filters.columns).some(item => item)
      const isSomeSnapshotsChecked = _.get(this.chartData, 'data', []).length > 1
      return !isSomeColumnChecked || !isSomeSnapshotsChecked
    },
    /**
     * This prop created as array of styles to handle pxPerDate changes and recalculate style
     */
    annotationStyles () {
      return this.annotations.map(i => {
        const left = this.pxPerDate * (Math.round(Math.abs((this.chartData.ticks[0].v - new Date(i.prevDate)) / MILISEC_ONE_DAY)))
        return {
          left: left + 'px',
          top: left <= 20 || left >= this.annotationsWrapperWidth - 30 ? '13px' : '0',
          'font-size': this.annotationSelectedDate === i.date ? '20px' : '14px'
        }
      })
    },
    isAnnotationMarkersShown () {
      return this.isAnnotationEnabled && !this.notEnoughData && !this.isScreenshotTaking
    },
    screenshotTitle () {
      return this.isScreenshotTaking ? _.get(this.getWebPropertyGroup(), 'label', '') : ''
    },
    /**
     * this property restricts date interval in picker
     * */
    dateRange () {
      const snapshots = this.snapshots ? this.snapshots.map(item => moment(item.label).toDate()) : []
      const first = snapshots.length > 0 ? moment(snapshots[0]).add(-1, 'd').toDate() : null
      const last = snapshots.length > 0 ? moment(snapshots[snapshots.length - 1]).add(1, 'd').toDate() : null
      return [first, last]
    },
    dates () {
      return this.snapshots.map(item => moment(item.label).toDate()) || []
    }
  },
  methods: {
    ...mapActions('rankZoneProgress', ['sortAnnotations', 'getProgressData']),
    /**
     * Preparing chart data for {@link BaseAreaChart} according to
     * {@link https://developers.google.com/chart/interactive/docs/datatables_dataviews#arraytodatatable}
     * @returns  chartData object with nex properties:
     *   data: array of chart data,
     *   colorSchema: array of colors,
     *   ticks: array of additional x-axis values see hAxis.ticks in chart options {@link https://developers.google.com/chart/interactive/docs/gallery/areachart#configuration-options }
     *
     */
    async loadPageData () {
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      await this.getProgressData({
        clientId: this.clientId,
        filters: { advancedFilters, web_property_group_id: this.webPropertyGroupId }
      })
      this.isDataFetched = true
    },
    updateColor (color) {
      const allColors = [...this.allColors]
      allColors[this.editorIndex] = color.colors.hex.length === 9 ? color.colors.hex.slice(0, -2) : color.colors.hex
      this.$set(this, 'allColors', allColors)
    },
    openEditor (index) {
      this.editorIndex = index === this.editorIndex ? null : index
    },
    prepareChartData () {
      const checkedColumns = this.cells.filter(item => this.filters.columns[item.label])
      const header = [ 'Snapshot', ...checkedColumns.map(cell => cell.label) ]
      const data = [header]
      let ticks = []
      let filteredSnapshots = this.snapshots
      if (this.filters.startDate || this.filters.endDate) {
        filteredSnapshots = this.snapshots.filter(item => moment(item.label).isBetween(this.filters.startDate, this.filters.endDate))
      }
      filteredSnapshots.forEach(
        (item, index, array) => {
          const entry = []
          entry.push(moment(item.label).toDate())
          const dateLabel = (index === 0 || index === array.length - 1) ? moment(item.label).format('YYYY-M-D') : ''
          ticks.push({ v: moment(item.label).toDate(), f: dateLabel })
          const selectedType = this.selectedType
          checkedColumns.forEach(cell => {
            let data = item[cell.propName]
            if (selectedType && Object.keys(item[selectedType]).length) {
              data = item[selectedType][cell.propName]
            }
            entry.push(data)
          })
          data.push(entry)
        }
      )
      const colorSchema = this.columns.reduce((acc, name, index) => {
        if (this.filters.columns[name]) {
          acc.push(this.allColors[index])
        }
        return acc
      }, [])
      this.chartData = {
        data,
        ticks,
        colorSchema
      }
    },
    getItemColor (index) {
      return { 'background-color': allColors[ index ] }
    },
    reset () {
      this.filters = { ...emptyFilters }
    },
    toogleAnnotation () {
      this.isAnnotationEnabled = !this.isAnnotationEnabled
    },
    selectAnnotationDate (date) {
      this.annotationSelectedDate = this.annotationSelectedDate === date ? '' : date
    },
    countPixelsPerDate () {
      if (this.isAnnotationMarkersShown) {
        this.throttle.flush()
        this.throttle()
      }
    },
    sendWebPropertyGroup () {
      this.$emit('web-property', this.getWebPropertyGroup())
    },
    getWebPropertyGroup () {
      return this.webPropertyGroupId
        ? this.webPropertyGroups.find(item => item.value === this.webPropertyGroupId)
        : null
    },
    /**
     * callback invoked when changed date range on date {@link BaseAreaChartDatePicker}
     * @param range - selected date range
     */
    onDateRangeChanged (range) {
      this.filters.startDate = range.date_from
      this.filters.endDate = range.date_to
      this.prepareChartData()
      this.$nextTick(this.countPixelsPerDate)
    },
    onScreenShotStatusChanged (status) {
      this.isScreenshotTaking = status
    }
  }
}
</script>

<style scoped lang="scss">

  .area-chart {
    flex: 1 1 100%;
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 10px;
    position: relative;

    &__annotation-button {
      border: solid 1px rgba(1, 22, 39, 0.1);
      background-color: transparent;
      border-radius: 4px;
      width: 105px;
      height: 40px;
      text-align: center;
      text-transform: uppercase;
      color: $rfx-dark-march;
      font-size: 10px;
      font-weight: 900;
      position: absolute;
      top: 15px;

      &_enabled {
        color: white;
        background-color: $rfx-cyan;
        border-color: $rfx-cyan !important;
      }
    }

    &__annotation-icons {
      position: relative;
      height: 16px;
      margin-top: -44px;
      margin-bottom: 28px;

      &_icon {
        width: 0px;
        cursor: pointer;
        position: absolute;

        &_system {
          color: $rfx-light-red;
        }

        &_client {
          color: $rfx-orange;
        }

        &_url {
          color: $rfx-cyan;
        }
      }
    }

    &__screenshot {
      font-size: 18px;
      cursor: pointer;

      &:hover {
        color: $rfx-bright-turquoise;
      }
    }
    &__wrapper{
      width: 100%;
      padding-top: 20px;
      box-sizing: border-box;
    }

    &__chart-subtitle {
      margin: 20px;
      font-weight: 500;
      color: $rfx-dark-march;

      &_highlighted{
        color: $rfx-light-blue;
      }
    }

    &__chart-wrapper {
      flex: 1 1 100%;
      display: flex;
      flex-direction: column;
    }

    &__web-property-select {
      width: 250px;
    }

    &__chart {
      flex: 1 1 100%;
      width: 97%;
    }

    &__ticks {
      width: 150px;
    }

    &__checkboxes{
      flex: 1 1 100%;
      padding: 30px 6% 30px 5%;
      display: grid;
      grid-template-columns: repeat(9, 1fr);
      grid-gap: 1vw;
    }

    &__checkbox{
      width: fit-content;
    }
    &__date-picker{
      position: absolute;
      top: 15px;
      right: 120px;
      height: 60px;
      z-index: 9;
    }

    &__competitor{
      background-color: $rfx-red;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      margin-right: 5px;
    }

    &__sibling{
      @extend .area-chart__competitor;
      background-color: $rfx-medium-orange;
    }

    &__client{
      @extend .area-chart__competitor;
      background-color: $rfx-light-green;
    }

    &__color {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
      }
  }

</style>
